import { LegalShell } from "@/pages/Legal";

const SECTIONS = [
  {
    title: "§ 1 Geltungsbereich",
    paras: [
      "Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der Terbeck Service GbR und ihren Kunden über die Erbringung von Dienstleistungen.",
      "Die Terbeck Service GbR bietet insbesondere Dienstleistungen in den Bereichen Hausmeisterservice, Objektbetreuung, Grundstücks- und Außenanlagenpflege, Garten- und Landschaftspflege, Reinigungsarbeiten, Instandhaltungs- und Pflegearbeiten, Entrümpelungen, Haushaltsauflösungen, Demontage- und Rückbauarbeiten sowie damit verbundene Transport- und Entsorgungsleistungen an.",
      "Der konkrete Leistungsumfang ergibt sich aus dem jeweiligen Angebot, Auftrag, Leistungsverzeichnis oder einer sonstigen individuellen Vereinbarung.",
      "Individuelle Vereinbarungen mit dem Kunden haben Vorrang vor diesen AGB.",
      "Diese AGB gelten gegenüber Verbrauchern und Unternehmern, soweit nicht einzelne Bestimmungen aufgrund zwingender gesetzlicher Vorschriften nur gegenüber Unternehmern Anwendung finden können.",
    ],
  },
  {
    title: "§ 2 Vertragsschluss",
    paras: [
      "Ein Vertrag kommt zustande, wenn der Kunde ein Angebot der Terbeck Service GbR annimmt oder die Terbeck Service GbR den Auftrag des Kunden ausdrücklich bestätigt.",
      "Angebote der Terbeck Service GbR sind grundsätzlich freibleibend, sofern sie nicht ausdrücklich als verbindlich bezeichnet werden.",
      "Der Umfang der geschuldeten Leistungen richtet sich nach dem bei Vertragsschluss vereinbarten Leistungsumfang.",
      "Zusätzliche Arbeiten, die vom Kunden nachträglich beauftragt werden, werden zusätzlich vergütet, sofern nicht ausdrücklich etwas anderes vereinbart wurde.",
      "Stellt sich während der Durchführung heraus, dass aufgrund bislang nicht erkennbarer Umstände zusätzliche Arbeiten erforderlich sind, wird die Terbeck Service GbR den Kunden hierüber nach Möglichkeit vor Durchführung informieren.",
    ],
  },
  {
    title: "§ 3 Preise und Vergütung",
    paras: [
      "Es gelten die im jeweiligen Angebot oder Auftrag vereinbarten Preise.",
      "Die Vergütung kann als Pauschalpreis, Stundenlohn, Einheitspreis oder nach tatsächlichem Aufwand vereinbart werden.",
      "Soweit nicht ausdrücklich anders vereinbart, können zusätzlich berechnet werden: Materialkosten, Fahrt- und Transportkosten, Entsorgungs- und Deponiekosten, Kosten für Fremdleistungen, Mietkosten für Maschinen, Geräte oder Spezialausrüstung sowie sonstige unmittelbar auftragsbezogene Kosten.",
      "Bei Leistungen nach Zeitaufwand wird die tatsächlich geleistete Arbeitszeit entsprechend der getroffenen Vereinbarung abgerechnet.",
      "Rechnungen sind, sofern auf der Rechnung oder im Auftrag nichts anderes angegeben ist, innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zur Zahlung fällig.",
      "Bei Zahlungsverzug gelten die gesetzlichen Vorschriften.",
    ],
  },
  {
    title: "§ 4 Mitwirkungspflichten des Kunden",
    paras: [
      "Der Kunde ist verpflichtet, der Terbeck Service GbR alle für die Durchführung des Auftrags erforderlichen Informationen vollständig und rechtzeitig zur Verfügung zu stellen.",
      "Der Kunde hat dafür zu sorgen, dass die zu bearbeitenden Bereiche zum vereinbarten Zeitpunkt zugänglich sind.",
      "Der Kunde hat die Terbeck Service GbR insbesondere über bekannte Gefahrenquellen, empfindliche Bereiche, besondere örtliche Gegebenheiten und sonstige Umstände zu informieren, die für die Durchführung der Arbeiten relevant sein können.",
      "Kann eine vereinbarte Leistung aufgrund fehlender Mitwirkung des Kunden nicht oder nicht rechtzeitig durchgeführt werden, ist die Terbeck Service GbR berechtigt, den dadurch entstehenden zusätzlichen Aufwand zu berechnen, soweit dieser vom Kunden zu vertreten ist.",
    ],
  },
  {
    title: "§ 5 Durchführung der Leistungen",
    paras: [
      "Die Terbeck Service GbR führt die vereinbarten Leistungen fachgerecht und mit der im jeweiligen Tätigkeitsbereich üblichen Sorgfalt aus.",
      "Bei witterungsabhängigen Arbeiten, insbesondere Arbeiten an Außenanlagen, Garten- und Grundstücksflächen, können sich Ausführungstermine aufgrund ungeeigneter Witterungsbedingungen verschieben.",
      "Die Terbeck Service GbR ist berechtigt, zur Durchführung einzelner Leistungen geeignete Mitarbeiter, Nachunternehmer oder sonstige Erfüllungsgehilfen einzusetzen.",
      "Die Terbeck Service GbR ist berechtigt, Arbeiten zu unterbrechen oder abzulehnen, wenn deren Durchführung eine erhebliche Gefahr für Personen, Gebäude, Fahrzeuge, sonstige Sachen oder die Umwelt darstellen würde oder gegen gesetzliche Vorschriften verstoßen könnte.",
    ],
  },
  {
    title: "§ 6 Hausmeister-, Objekt- und Grundstücksservice",
    paras: [
      "Umfang und Häufigkeit der Hausmeister-, Objekt- und Grundstücksleistungen richten sich nach dem jeweiligen Auftrag.",
      "Nicht ausdrücklich vereinbarte Leistungen sind nicht Bestandteil des Auftrags und werden nur nach gesonderter Vereinbarung durchgeführt.",
      "Bei regelmäßig wiederkehrenden Leistungen kann der Leistungsumfang durch einen individuellen Leistungsvertrag, ein Leistungsverzeichnis oder einen Betreuungsplan konkretisiert werden.",
      "Die Terbeck Service GbR übernimmt keine Leistungen, für die besondere gesetzliche Zulassungen, Qualifikationen oder Fachbetriebe erforderlich sind, sofern diese nicht ausdrücklich Bestandteil des Auftrags sind.",
    ],
  },
  {
    title: "§ 7 Garten-, Außenanlagen- und Pflegearbeiten",
    paras: [
      "Bei Garten-, Grundstücks- und Außenanlagenarbeiten können aufgrund der natürlichen Entwicklung von Pflanzen, Witterung, Jahreszeit und örtlichen Gegebenheiten Abweichungen vom ursprünglichen Zustand auftreten.",
      "Die Terbeck Service GbR haftet nicht für natürliche Entwicklungen oder Schäden, die ausschließlich durch Witterung, Sturm, Frost, Hitze, Trockenheit, Schädlingsbefall oder sonstige nicht von ihr zu vertretende äußere Einwirkungen entstehen.",
      "Pflanzenschutz-, Baumfäll- oder sonstige Arbeiten, für die besondere Genehmigungen oder Qualifikationen erforderlich sind, werden nur im Rahmen der gesetzlichen Zulässigkeit und einer entsprechenden Vereinbarung durchgeführt.",
    ],
  },
  {
    title: "§ 8 Entrümpelungen und Haushaltsauflösungen",
    paras: [
      "Bei Entrümpelungen und Haushaltsauflösungen ist der Kunde dafür verantwortlich, der Terbeck Service GbR eindeutig mitzuteilen, welche Gegenstände nicht entfernt werden dürfen.",
      "Gegenstände, die ausdrücklich zur Entfernung, Verwertung oder Entsorgung freigegeben wurden, dürfen entsprechend dem Auftrag behandelt werden.",
      "Der Kunde hat insbesondere auf Wertgegenstände, Bargeld, Schmuck, persönliche Unterlagen, Dokumente und sonstige Gegenstände von besonderem Wert hinzuweisen und diese vor Beginn der Arbeiten selbst zu sichern.",
      "Die Terbeck Service GbR ist nicht verpflichtet, den Wert von Gegenständen zu prüfen, die zur Entfernung oder Entsorgung freigegeben wurden.",
      "Die Entsorgung erfolgt im Rahmen der gesetzlichen Vorschriften.",
      "Besondere Entsorgungskosten, die bei Auftragserteilung nicht bekannt waren und nicht im vereinbarten Preis enthalten sind, können zusätzlich berechnet werden, sofern dies rechtlich zulässig ist.",
      "Gefährliche Stoffe, Schadstoffe oder Gegenstände, deren Transport oder Entsorgung besonderen gesetzlichen Anforderungen unterliegen, werden nur nach vorheriger ausdrücklicher Vereinbarung übernommen.",
    ],
  },
  {
    title: "§ 9 Transport- und Überführungsleistungen",
    paras: [
      "Bei Transportleistungen hat der Kunde vollständige und richtige Angaben über das Transportgut sowie Abhol- und Zielort zu machen.",
      "Der Kunde hat die Terbeck Service GbR auf besondere Eigenschaften oder Risiken des Transportgutes hinzuweisen.",
      "Bei Fahrzeugüberführungen hat der Kunde, soweit nicht anders vereinbart, dafür zu sorgen, dass sich das Fahrzeug in einem für die vereinbarte Überführung geeigneten Zustand befindet.",
      "Der Kunde hat insbesondere auf bekannte technische Mängel, Schäden, Besonderheiten oder Einschränkungen des Fahrzeugs hinzuweisen.",
      "Für Schäden, die aufgrund falscher oder unvollständiger Angaben des Kunden entstehen, gelten die gesetzlichen Vorschriften.",
    ],
  },
  {
    title: "§ 10 Termine und Verzögerungen",
    paras: [
      "Vereinbarte Ausführungstermine sind nur verbindlich, wenn sie ausdrücklich als verbindlich vereinbart wurden.",
      "Verzögerungen aufgrund von höherer Gewalt, ungeeigneter Witterung, fehlender Mitwirkung des Kunden, behördlichen Maßnahmen, Lieferverzögerungen oder sonstigen Umständen, die die Terbeck Service GbR nicht zu vertreten hat, berechtigen zu einer angemessenen Verschiebung des Ausführungstermins.",
      "Die Terbeck Service GbR wird den Kunden über absehbare Verzögerungen nach Möglichkeit informieren.",
    ],
  },
  {
    title: "§ 11 Abnahme und Mängel",
    paras: [
      "Soweit die Art der Leistung eine Abnahme voraussetzt, hat der Kunde die Leistung nach Fertigstellung abzunehmen.",
      "Erkennbare Mängel oder Beanstandungen sind der Terbeck Service GbR möglichst unverzüglich mitzuteilen.",
      "Die gesetzlichen Mängelrechte des Kunden bleiben unberührt.",
      "Bei berechtigten Mängeln erhält die Terbeck Service GbR grundsätzlich die Möglichkeit, innerhalb angemessener Frist nachzubessern, soweit dies gesetzlich zulässig und technisch möglich ist.",
      "Eine Abnahme gilt nicht als Verzicht auf gesetzliche Ansprüche wegen eines bei der Abnahme nicht erkennbaren Mangels.",
    ],
  },
  {
    title: "§ 12 Haftung",
    paras: [
      "Die Haftung der Terbeck Service GbR richtet sich nach den gesetzlichen Vorschriften.",
      "Die Terbeck Service GbR haftet insbesondere für Schäden, die vorsätzlich oder grob fahrlässig verursacht wurden, sowie in den Fällen, in denen eine Haftung aufgrund zwingender gesetzlicher Vorschriften besteht.",
      "Für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit gelten die gesetzlichen Haftungsvorschriften.",
      "Eine Haftungsbeschränkung gilt nicht, soweit die Terbeck Service GbR zwingend gesetzlich haftet.",
      "Der Kunde hat die Terbeck Service GbR vor Beginn der Arbeiten auf besondere Risiken, empfindliche Gegenstände, Vorschäden oder sonstige relevante Besonderheiten hinzuweisen.",
    ],
  },
  {
    title: "§ 13 Eigentum und freigegebene Gegenstände",
    paras: [
      "Bei Entrümpelungen, Haushaltsauflösungen und vergleichbaren Leistungen bleiben Gegenstände, die nicht ausdrücklich zur Entfernung freigegeben wurden, grundsätzlich im Eigentum bzw. Besitz des Kunden.",
      "Für Gegenstände, die vom Kunden ausdrücklich zur Entsorgung, Verwertung oder Entfernung freigegeben wurden, übernimmt die Terbeck Service GbR keine Verantwortung für einen möglicherweise später behaupteten wirtschaftlichen oder persönlichen Wert, soweit gesetzlich zulässig.",
      "Der Kunde ist dafür verantwortlich, vor Beginn der Arbeiten persönliche Gegenstände und Wertgegenstände zu sichern.",
    ],
  },
  {
    title: "§ 14 Stornierung und Kündigung",
    paras: [
      "Die Kündigung oder Stornierung eines Auftrags richtet sich nach den gesetzlichen Vorschriften und den individuellen Vereinbarungen.",
      "Bei einer kurzfristigen Absage oder Nichtbereitstellung des Leistungsortes können der Terbeck Service GbR die hierdurch nachweislich entstandenen und nicht vermeidbaren Kosten in Rechnung gestellt werden, soweit dies gesetzlich zulässig ist.",
      "Bereits erbrachte Leistungen sowie bereits entstandene Material-, Transport-, Entsorgungs- oder Fremdkosten sind entsprechend den gesetzlichen Vorschriften zu vergüten.",
    ],
  },
  {
    title: "§ 15 Aufrechnung und Zurückbehaltungsrecht",
    paras: [
      "Der Kunde darf nur mit solchen Forderungen aufrechnen, die rechtskräftig festgestellt, unbestritten oder von der Terbeck Service GbR anerkannt sind. Gesetzliche Zurückbehaltungsrechte bleiben unberührt.",
    ],
  },
  {
    title: "§ 16 Datenschutz",
    paras: [
      "Die Terbeck Service GbR verarbeitet personenbezogene Daten im Rahmen der geltenden datenschutzrechtlichen Vorschriften.",
      "Weitere Informationen zur Verarbeitung personenbezogener Daten ergeben sich aus der jeweils aktuellen Datenschutzerklärung der Terbeck Service GbR.",
    ],
  },
  {
    title: "§ 17 Verbraucher und gesetzliches Widerrufsrecht",
    paras: [
      "Bei Verträgen mit Verbrauchern gelten die gesetzlichen Vorschriften zum Verbraucherschutz.",
      "Soweit einem Verbraucher bei einem Vertrag ein gesetzliches Widerrufsrecht zusteht, wird der Kunde hierüber gesondert entsprechend den gesetzlichen Anforderungen informiert.",
      "Das Bestehen oder Nichtbestehen eines Widerrufsrechts richtet sich nach der konkreten Vertragsart und den gesetzlichen Vorschriften.",
    ],
  },
  {
    title: "§ 18 Gerichtsstand und anwendbares Recht",
    paras: [
      "Es gilt das Recht der Bundesrepublik Deutschland.",
      "Gegenüber Verbrauchern gelten die gesetzlichen Bestimmungen zum Gerichtsstand.",
      "Gegenüber Unternehmern kann, soweit gesetzlich zulässig, als Gerichtsstand der Sitz der Terbeck Service GbR vereinbart werden.",
    ],
  },
  {
    title: "§ 19 Schlussbestimmungen",
    paras: [
      "Individuelle Vereinbarungen zwischen der Terbeck Service GbR und dem Kunden haben Vorrang vor diesen AGB.",
      "Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleiben die übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung treten die gesetzlichen Vorschriften.",
      "Änderungen und Ergänzungen des jeweiligen Auftrags können individuell vereinbart werden.",
    ],
  },
];

export default function Agb() {
  return (
    <LegalShell
      title="AGB"
      subtitle="Allgemeine Geschäftsbedingungen der Terbeck Service GbR · Stand: September 2026"
      testid="agb-page"
    >
      <div>
        {SECTIONS.map((s) => (
          <section key={s.title} className="border-t border-white/10 pt-8 mt-8 first:border-t-0 first:pt-0 first:mt-0">
            <h2 className="font-display text-lg md:text-xl font-bold uppercase tracking-tight text-white">
              {s.title}
            </h2>
            <div className="mt-4 space-y-3 text-sm md:text-base leading-relaxed text-white/60">
              {s.paras.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </section>
        ))}
        <footer className="mt-12 rounded-xl border border-white/10 bg-surface p-6 text-sm text-white/60">
          <p className="font-bold text-white">Terbeck Service GbR</p>
          <p>Julian Rehers · Riekenhofweg 29 · 48599 Gronau (Westf.)</p>
          <p>Telefon: 0151 50778186 · E-Mail: info@terbeck-service.de</p>
          <p className="mt-2 text-white/40">Stand: September 2026</p>
        </footer>
      </div>
    </LegalShell>
  );
}
